import tchat from '@amo/core/assets/images/AMO_Icons/Chat.svg';
import info from "@amo/core/assets/images/icons/info.svg";
import { Question, BulleAide } from '@amo/core/components/containers';
import { Radio } from '@amo/core/components/forms';
import { Field } from 'redux-form';
import _ from "lodash";
import moment from "moment";
import queryString from "query-string";
import { useState } from "react";

const MotifAvenant = (props) => {
    const { nextQuestion, data, isMAJDec, source, initialValues, isRemiseVigueur, hasRegul, hasFid } = props;

    /* Redirection depuis le formulaire de déménagement (changement de zone) : seul le motif "Changement d'adresse" est proposé */
    const onlyChangementAdresse = queryString.parse(window.location.search).motifAdresse === '1';
    /* Le motif "Changement d'adresse" n'est plus proposé dans l'avenant standard côté client (direct/site) : il passe par le formulaire de déménagement */
    const isClient = !_.includes(['conseiller', 'courtier'], source);

    const isMajeur = (index) => {
        const dateNaissance = _.get(initialValues, `DemandeTarif[ListePersonnes][${index}][DateNaissance]`);
        const birthMoment = moment(dateNaissance, 'DD/MM/YYYY');
        return moment.isMoment(birthMoment) && birthMoment.add(18, 'years') <= moment();
    }

    const idRealisateur = _.get(initialValues, 'DemandeTarif[Police][IdRealisateur]');
    const realisateursFid = [
        500078, // DOS-SANTOS Julie
        500093, // MERY Audrey
        500145, // BEDARD Anais
        500241, // MASSETEAU Hugo
        500272, // LE GLEUHER Iris
        530134, // LE COQ Anais
        539651, // DESMAY Maeva
        544205, // HEDDAD Mira
        546082, // ROCHER Paul
        783963, // GUILLET Nil
        810536, // PALMOT Lucie
        810660, // BENETEAU Gaetan
        823257, // BRUNET Vanessa
        826576, // EL ALLAM Chahrrane
        829447, // RUIZ Allan
        831252, // LOGNONE Mathis
        831889, // BOISSEAU Yanis
    ];

    const isRealisateurFid = realisateursFid.includes(idRealisateur);

    const isAFN6Mois = moment(_.get(data, 'DemandeTarif[Police][DateAffaireNouvelleContrat]'), 'DD/MM/YYYY').add(6, 'months') < moment();
    const isDerPiece3Mois = moment(_.get(data, 'DemandeTarif[Police][DateEffetContrat]'), 'DD/MM/YYYY').add(3, 'months') < moment();

    const ListePersonnes0Majeur = isMajeur(0);
    const ListePersonnes1Majeur = isMajeur(1);
    const [blocageMajeurs, setBlocageMajeurs] = useState(false);

    const onClickNext = (motif) => {
        if (!(ListePersonnes0Majeur && ListePersonnes1Majeur) || motif === '5') {
            setBlocageMajeurs(false);
            nextQuestion(300)
        } else {
            setBlocageMajeurs(true);
        }
    };

    const renderRadio = (value, label, disabled = false) => (
        <div className={'col-lg-4 col-md-6 col-sm-6 col-6 my-2'}>
            <Field
                component={Radio}
                type={'radio'}
                name={'DemandeTarif[Police][MotifAvenant]'}
                value={value}
                label={label}
                disabled={disabled}
                onClick={(e) => onClickNext(e.target.value)}
            />
        </div>
    );

    return (
        <Question icon={tchat} title={'Quel est le <b>motif de votre avenant</b>&nbsp;?'}>
            <div className={'row justify-content-center mt-2'}>
                {onlyChangementAdresse ? (
                    renderRadio('3', "Changement d'adresse")
                ) : hasFid ? (
                    renderRadio('29', 'Avenant de fidélisation')
                ) : hasRegul ? (
                    renderRadio('7', 'Régularisation de prime')
                ) : (
                    <>
                        {(isMAJDec && source === 'conseiller') ? <>
                                {renderRadio('8', 'Mise à jour de déclaration')}
                            </> :
                            <>
                                {(!isRemiseVigueur) && (
                                    <>
                                        {renderRadio('1', 'Changement de véhicule')}
                                        {renderRadio('2', 'Changement de garanties')}
                                        {!isClient && renderRadio('3', "Changement d'adresse")}
                                        {(Number(data?.cylindreeVehicule) <= 50 && source === 'conseiller') && renderRadio('5', "Changement de conducteur")}
                                        {!_.includes(['quad', 'verte'], data?.typeVehicule) && renderRadio('9', "Changement d'usage")}
                                    </>
                                )}

                                {source === 'conseiller' && (
                                    <>
                                        {renderRadio('7', 'Régularisation de prime', !isRealisateurFid)}
                                        {renderRadio('10', 'Modification de contrat')}
                                        {renderRadio('11', 'Correctif d\'avenant', isDerPiece3Mois)}
                                        {renderRadio('8', 'Mise à jour de déclaration', isAFN6Mois)}
                                        {renderRadio('29', 'Avenant de fidélisation', !isRealisateurFid)}
                                    </>
                                )}

                                {isRemiseVigueur && (
                                    <>
                                        {renderRadio('1', 'Changement de véhicule')}
                                        {renderRadio('6', 'Remise en vigueur')}
                                    </>
                                )}
                            </>
                        }
                    </>
                )}
            </div>

            {blocageMajeurs && (
                <div className="alert alert-danger mt-3 col-lg-8 offset-lg-2" role="alert">
                    <p className="mb-1">Pas de modification possible car le conducteur est devenu majeur.</p>
                    <p className="mb-0">Merci de refaire une affaire nouvelle.</p>
                </div>
            )}
            {!onlyChangementAdresse && (
                <BulleAide
                    icon={info}
                    title={(source !== 'site') ? 'Si vous changez de véhicule et que vous souhaitez changer d\'usage et de garanties, passez par le motif "Changement de véhicule".<br/><br/>' +
                        'Si vous avez plusieurs modifications à faire sur le contrat (changement d’adresse + véhicule par exemple), merci de passer par le motif “Modification de contrat”.' : 'Si vous changez de véhicule et que vous souhaitez changer d\'usage et de garanties, passez par le motif "Changement de véhicule".'
                    }
                    className={'col-lg-12 col-md-12 mb-1 mt-2'}
                />
            )}
            <button
                className={`btn btn-primary btn-arrow mt-4 ${(!_.get(data, 'DemandeTarif[Police][MotifAvenant]') || blocageMajeurs) && 'disabled'}`}
                onClick={() => onClickNext(_.get(data, 'DemandeTarif[Police][MotifAvenant]'))}
            >
                Continuer
            </button>
        </Question>
    );
};

export default MotifAvenant;
